export default __webpack_public_path__ + "static/media/sc20.4d7772e7.mp4";